import { UPDATE_JOB_FORM } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_JOB_FORM.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_JOB_FORM.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_JOB_FORM.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
